export default __webpack_public_path__ + "src/assets/bitcoin.b6e96b8a3ee8010c61d75efab050feb1.svg";